// eslint-disable-next-line
import WordPairs from "./container/WordPairs"
// eslint-disable-next-line
import { actions, actions as wordPairsContainerActions } from './actions'

export const NAME = 'WORD_PAIRS'
export const types = {
  GET_SUBSCRIPTION_REQUEST: `${NAME}/GET_SUBSCRIPTION_REQUEST`,
}

export const initialState = {
  //POINTS_PER_CLICK: 2.75,
  POINTS_PER_CLICK: 6,
  autoHelp: {
    remainingForAutoHelp: 1,
    list: [],
    index: 0
  },
  gameMatrix: [],
  leftToFind: 10,
  currentRound: 0,
  points: 0,
  timeLeft: 60,
  countDown: 3,
  wrongAnswers: 0,
  exersizeState: "startScrean"
}



export function reducer(state = initialState, action) {
  switch (action.type) {
    case "PREEXERSIZE":
      return {
        ...state,
        exersizeState: "preexersize"
      };
    case "INCREMENT_COUNTDOWN":
      return {
        ...state,
        countDown: state.countDown - 1,
      };
    case "INCREMENT":
      return {
        ...state,
        timeLeft: state.timeLeft - 1
      }
    case "SET_INCREMENT_COUNT_DOWN":
      return {
        ...state,
        countDown: action.newCountDown
      }
    case "START_GAME":
      return {
        ...state,
        exersizeState: "gameStarted"
      }
    case "GENERATE_MATRIX":      
        return {
          ...state,
          leftToFind: action.leftToFind,
          gameMatrix: action.gameMatrix,
          autoHelp: action.autoHelp
        }
    case "CELL_CLICK": {
      return {
        ...state,
        gameMatrix: action.gameMatrix,
        points: action.points,
        wrongAnswers: action.wrongAnswers,
        timeLeft: action.timeLeft,
        exersizeState: action.exersizeState,
        leftToFind: action.leftToFind,
        autoHelp: action.autoHelp
      }
    }
    case "GAME_OVER": {
      return {
        ...state,
        exersizeState: 'gameOver'
      }
    }
    case "SHOW_GAME_OVER_SCREAN": {
      return {
        ...state,
        exersizeState: 'scoreScrean'
      }
    }
    case "NEW_ROUND": {
      return {
        ...state,
        currentRound: action.currentRound,
      }
    }
    default:
      return { ...state }
  }
}
